@if (content) {
<div class="w-12 left flex flex-column flex-justify-between overflow-y-auto"
     style="height:100%">
     <div class="w-12 p1"
          *iCms="'text' of content; content: 'html'"></div>
     @if (content.image) {
     <div class="pos-relative w-12 m-t m-b">
          <img [dfImage]="content.image"
               [ratio]="content.ratio"
               [alt]="content.text"
               fill>
     </div>
     }
</div>
}